import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { CellContext } from '@tanstack/react-table';

export interface UserListLastNameCellProps
  extends CellContext<GatewayUserModel, GatewayUserModel['lastName']> {}

export const UserListLastNameCell = (
  props: UserListLastNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
